module.exports = __webpack_public_path__ + "Na_logo-87d4ac02739e56855d76.svg";